"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealmType = void 0;
/**
 * All the realm types
 */
var RealmType;
(function (RealmType) {
    RealmType["Main"] = "main";
    RealmType["Custom"] = "custom";
})(RealmType || (exports.RealmType = RealmType = {}));
